var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buy-credits" }, [
    _c("div", { staticClass: "buy-credits__center" }, [
      _c(
        "div",
        { staticClass: "buy-credits__selectorwrap" },
        [
          _c("div", [_vm._v(_vm._s(_vm.$t("buyCredits.title")))]),
          _c("vue-slider-wrap", {
            attrs: { credits: _vm.credits },
            on: { creditsData: _vm.getCreditsData }
          }),
          _c("div", { staticClass: "buy-credits__more" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("buyCredits.bigPurchases", {
                    credits: _vm.formatCredits(_vm.creditsData.endCreditsSlider)
                  })
                ) +
                " "
            ),
            _c("a", { attrs: { href: "mailto:info@game-learn.com" } }, [
              _vm._v(_vm._s(_vm.$t("buyCredits.contact")))
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "buy-credits__colright" }, [
        _c("div", { staticClass: "buy-credits__biginput" }, [
          _c("form", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.credits,
                  expression: "credits"
                }
              ],
              staticClass: "credits",
              attrs: {
                id: "account.credit.slider",
                min: _vm.creditsData.startCreditsSlider,
                max: _vm.creditsData.endCreditsSlider,
                type: "number"
              },
              domProps: { value: _vm.credits },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) return
                    _vm.credits = $event.target.value
                  },
                  _vm.checkInputValue
                ]
              }
            })
          ]),
          _c("span", [_vm._v(_vm._s(_vm.$t("buyCredits.credits")))])
        ]),
        _c(
          "div",
          { staticClass: "buy-credits__cta" },
          [
            _c("div", { staticClass: "buy-credits__total" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$n(_vm.subtotal, "currency", _vm.currency)) +
                  " "
              )
            ]),
            _c("div", { staticClass: "u-font-x-small" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$n(_vm.pricePerCredit, "currency", _vm.currency)) +
                  " / " +
                  _vm._s(_vm.$t("buyCredits.credit").toLowerCase()) +
                  " "
              )
            ]),
            _c("gl-button", {
              staticClass: "buy-credits__submit",
              attrs: {
                id: "account.credit.btn-credit",
                "color-primary": "",
                type: "submit",
                text: _vm.$t("actions.buy"),
                disabled: !_vm.validNumber
              },
              on: {
                onClick: function($event) {
                  $event.preventDefault()
                  return _vm.goToPayment.apply(null, arguments)
                }
              }
            })
          ],
          1
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "buy-credits__cancelwrap" },
      [
        _c("gl-button", {
          attrs: {
            id: "account.credit.btn-cancel",
            "color-secondary": "",
            type: "submit",
            text: _vm.$t("actions.cancel")
          },
          on: {
            onClick: function($event) {
              $event.preventDefault()
              return _vm.goBack.apply(null, arguments)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }